/* eslint-disable @next/next/no-img-element */
import { Fragment } from "react";

import Head from "next/head";

import placeholder from "assets/placeholder.jpeg";

type BunnyPictureProps = {
  className?: string;
  imgClassName?: string;
  draggable?: boolean;
  preload?: boolean;
  src: string;
  sizes: { media: string; width: string }[];
  alt: string;
  width: number;
  height: number;
};

// Remove px from width
const getWidthParam = (width: string) => {
  return width.replace(/px$/, "");
};

const getSrc = (src: string, width: string) => {
  // The gateway returns "" for an image whose file never arrived (e.g. a feed
  // image URL that 404s). Show the placeholder instead of an empty <img>.
  if (!src) {
    return placeholder.src;
  }

  try {
    const srcObj = new URL(src);
    srcObj.searchParams.delete("height");
    srcObj.searchParams.set("width", getWidthParam(width));
    return srcObj.href;
  } catch (e) {
    return src;
  }
};

export const BunnyPicture = (props: BunnyPictureProps) => {
  const { className, imgClassName, alt, sizes, width, height, preload } = props;

  return (
    <picture className={className}>
      {sizes.map((currentSize, index, sizes) => {
        const src = getSrc(props.src, currentSize.width);

        return (
          <Fragment key={`${currentSize.media}-${currentSize.width}`}>
            {preload && (
              <Head>
                <link
                  rel="preload"
                  href={src}
                  as="image"
                  media={currentSize.media}
                  fetchPriority="high"
                />
              </Head>
            )}
            <source media={currentSize.media} srcSet={src} />
            {index === sizes.length - 1 && (
              <img
                className={imgClassName}
                src={src}
                width={width}
                height={height}
                alt={alt}
                loading={preload ? "eager" : "lazy"}
              />
            )}
          </Fragment>
        );
      })}
    </picture>
  );
};
